import classNames from 'classnames';
import styles from './ServiceNavigation.module.scss';
import { LanguagePicker, Link, LinkButton } from 'ui/components';
import { useMemo } from 'react';

export interface ServiceNavigationProps {
	className?: string;
	serviceNavigationItems?: Navigation.NestedNavigationItem[];
	isLoggedIn?: boolean;
	isNavActive?: boolean;
	isAvatarActive?: boolean;
	handleClick?: () => void;
	continents?: Umbraco.Continent[];
	dictionary?: { [key: string]: string };
}

const renderNavItem = (item: Navigation.NestedNavigationItem, handleClick?: () => void) => {
	if (item.showAsButton) {
		return (
			<LinkButton style="secondary" {...item} target={item.target}>
				{item.title || item.name}
			</LinkButton>
		);
	}

	if (item.url?.startsWith('#')) {
		return (
			<a className={styles.ServiceNavigation_link} href={item.url} target={item.target} onClick={handleClick} aria-label={item.name}>
				{item.title || item.name}
			</a>
		);
	}

	return (
		<Link className={styles.ServiceNavigation_link} {...item} target={item.target} handleClick={handleClick} url={item?.url}>
			{item.title || item.name}
		</Link>
	);
};

export const ServiceNavigation: React.FC<ServiceNavigationProps> = (props) => {
	const { className, serviceNavigationItems, isLoggedIn, isNavActive, isAvatarActive, handleClick, continents, dictionary } = props;

	const continentsData = useMemo(() => (continents ?? []).map((c: any) => c?.properties ?? c).filter(Boolean), [continents]);

	if (!serviceNavigationItems) return null;

	return (
		<ul
			className={classNames(styles.ServiceNavigation, className, {
				[styles.isNavActive]: isNavActive,
				[styles.isAvatarActive]: isAvatarActive,
				[styles.isLoggedIn]: isLoggedIn,
			})}
		>
			{serviceNavigationItems.map((item, index) => (
				<li key={index} className={styles.ServiceNavigation_item}>
					{renderNavItem(item, handleClick)}
				</li>
			))}

			{continentsData.length > 0 && (
				<li className={styles.ServiceNavigation_item}>
					<LanguagePicker
						className={styles.ServiceNavigation_language}
						continentsData={continentsData}
						continentsRaw={continents}
						modalTitle="Select country and language"
						dictionary={dictionary}
					/>
				</li>
			)}
		</ul>
	);
};
